import { SoilUnit } from "../soil"

export interface SoilUnitOption {

    id: SoilUnit

    /** Full label, including "Olsen" and "Morgan" labels */
    label: string

}

const supportedUnitsArray = [

    {
        id: SoilUnit.Index,
        text: "Index",
        label: "Index",
        soil: true,
        nitrogen: true
    },

    {
        id: SoilUnit.Ppm,
        text: "ppm",
        label: "Olsen ppm",
        soil: true,
        nitrogen: false
    },

    {
        id: SoilUnit.Morgan,
        text: "mg/l",
        label: "Morgan mg/l",
        soil: true,
        nitrogen: false
    },

    {
        id: SoilUnit.KgHa,
        text: "kg/ha",
        label: "kg/ha",
        soil: false,
        nitrogen: true
    },

]

const supportedUnits = Object.fromEntries(supportedUnitsArray.map(a => [a.id, a]))

const soilOptions = supportedUnitsArray.filter(u => u.soil)

export function getSoilUnitOption(unit: SoilUnit) {
    return supportedUnits[unit]
}

export function getSoilUnitOptions(): SoilUnitOption[] {
    return soilOptions
}

export function getSoilUnitText(unit: SoilUnit) {
    return supportedUnits[unit]?.text
}

/**
 * Returns the unit to display in a context defined by "morgan" and "index" boolean flags,
 * which indicate if index / Morgan are supported
 */
export function getSoilUnitLabel(unit: SoilUnit, context?: { index?: boolean, morgan?: boolean }) {

    if (!context) {
        return supportedUnits[unit]?.label
    }

    const { index, morgan } = context

    if (index && (unit === SoilUnit.Index)) {
        return supportedUnits[unit].label
    }

    if (morgan && (unit === SoilUnit.Morgan)) {
        return supportedUnits[unit].label
    }

    return supportedUnits[SoilUnit.Ppm].label

}
